import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import { LayerChange, ReportBugs } from '../icons/index';
import SearchIcon from '@material-ui/icons/Search';
//import { makeStyles } from '@material-ui/core/styles';

/*const useStyles = makeStyles({
    label: {
      textTransform: 'capitalize',
    },
  });*/

class ButtonComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showText: true
    };

    this.resizeFunction = this.resizeFunction.bind(this);
  }

  getIcon = (icon) => {
	if (this.state.showText) {
		return null;
	}

    switch (icon) {
      case 'layer':
        return <LayerChange viewBox="-3 -7 32 32" />;

      default:
        if (this.props.text == window.displayText('PERSON_SEARCH')) {
          return <SearchIcon viewBox="1 -2 22 22" />;
        }

        return <ReportBugs viewBox="6 1 22 22" />;
    }
  }

  componentDidMount() {
    this.resizeFunction();
    window.addEventListener('resize', this.resizeFunction);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeFunction);
  }

  resizeFunction() {
    this.setState({ showText: window.innerWidth > 700 });
  }

  render() {
    const {onClick, text, position, enabled, width, icon} = this.props;

    return (

      <Button
        onClick={e => {
          onClick(e, !enabled);
        }}
        size="medium"
        variant="contained"
        enabled={((enabled || typeof enabled === 'undefined') ? 'enabled' : '')}
        //classes={{label: classes.label}}
        style={{
            backgroundColor: '#fff',
            borderRadius: 0,
            fontFamily: 'Pluto Sans Cond Bold',
            fontSize: '1em',
            justifyContent: 'flex-start',
            margin: this.state.showText ? '0 4px 0 0': '0',
            minWidth: 'unset',
            padding: this.state.showText ? '10px 18px 8px 18px': '5px 9px',
            textTransform: 'none',
        }}
      >
        <div style={{float: 'left', marginTop: this.state.showText ? '0': '1px'}}>{this.getIcon(icon)}</div>
        {this.state.showText ? (
          <div>{text}</div>
        ):(
          <div></div>
        )}
      </Button>
    );
  }
}

ButtonComp.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  position: PropTypes.array,
  enabled: PropTypes.bool,
  width: PropTypes.string,
  icon: PropTypes.string
}

export default ButtonComp



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/buttons/button.js